import { call, put, takeLatest } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { accountSetupApi } from '../../api/apiLists/accountSetupApi';
import { setupAccountRequest, setupAccountSuccess, setupAccountFailure } from '../accountSetupSlice';

function* handleAccountSetup(action) {
    try {
        yield put(setupAccountRequest());
        const { state = 'WHATSAPP_SIGNUP' } = action.payload || {};

        const payload = {
            operation: 'accountSetup',
            payload: {
                state
            }
        };

        const res = yield call(callWithAuth, accountSetupApi, payload);

        if (res?.companyId) {
            yield put(setupAccountSuccess({
                companyId: res.companyId,
                message: res.message
            }));
        } else {
            yield put(setupAccountFailure('Account setup failed: No companyId returned'));
        }
    } catch (err) {
        yield put(setupAccountFailure(err.message || 'Account setup failed'));
    }
}

export default function* accountSetupSaga() {
    yield takeLatest('SETUP_ACCOUNT', handleAccountSetup);
}
